module.exports = __webpack_public_path__ + "static/media/pzl11.e8e0744e.jpg";